export default __webpack_public_path__ + "static/media/Aura-Egg__73.9b3af509.png";